import React from 'react';
import { useTranslation } from 'react-i18next';

import { Users } from 'icons/untitledui';

// styles
import * as Text from 'theme/components/Text.style';
import * as ContributorsStyles from 'teamLeadInsights/styles/Contributors.style';

// helpers
import getShiftContributors from 'teamLeadInsights/helpers/getShiftContributors';

// types
import { SiteShift } from 'shiftNotes/_types';

export default function Contributors({
  shift,
}: {
  shift: SiteShift;
}): JSX.Element | null {
  const { t } = useTranslation('pageTeamLeadInsights');

  const contributors = getShiftContributors(shift);

  if (contributors.length === 0) return null;

  return (
    <>
      <Text.P2Semibold>{t('viewTeamLead.Contributors')}</Text.P2Semibold>
      <ContributorsStyles.ContributorList>
        {contributors.map((contributor) => (
          <ContributorsStyles.ContributorContainer key={contributor}>
            <ContributorsStyles.ContributorIcon>
              <Users.User01 size={24} />
            </ContributorsStyles.ContributorIcon>
            <Text.P1Semibold>{contributor}</Text.P1Semibold>
          </ContributorsStyles.ContributorContainer>
        ))}
      </ContributorsStyles.ContributorList>
    </>
  );
}
